import {DepartmentsAPI} from "../api/DepartmentsAPI";
import {AppStore} from "../desktop";
import {actionDepartmentsFetchAllCompleted, actionDepartmentsFetchCompleted} from "../store/departments/actions";
import {BaseService} from "./BaseService";
import {Department} from "../models/Department";
import {DepartmentsActionTypes} from "../store/departments";
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions";
import {ErrorService} from "./ErrorService";
import {actionToastrInfo} from "../store/global";

export default class DepartmentsService extends BaseService {

	static getAll() {

        let departmentsAPI: DepartmentsAPI = new DepartmentsAPI()

		departmentsAPI.getAll().then(DepartmentsService.processResponse)
		.then((result) => actionDepartmentsFetchAllCompleted(DepartmentsService.fromAPIList(result)))
		.catch(error => ErrorService.handleError(error))
	}

    static getOne(department: Department) {

        let departmentsAPI: DepartmentsAPI = new DepartmentsAPI()

        departmentsAPI.get(department).then(DepartmentsService.processResponse).then(result => {
			actionDepartmentsFetchCompleted(DepartmentsService.fromAPIItem(result))
        }).catch(error => ErrorService.handleError(error))

    }

    static save(department: Department) {

        let departmentsAPI: DepartmentsAPI = new DepartmentsAPI()

		if (department.id) {
			departmentsAPI.put(DepartmentsService.itemToRequest(department)).then(DepartmentsService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: DepartmentsActionTypes.SAVE_COMPLETED, payload: DepartmentsService.fromAPIItem(data)
					})
					actionSetTabStateItem(DepartmentsService.fromAPIItem(data))
					actionSetTabItem(DepartmentsService.fromAPIItem(data))
					actionToastrInfo("Info", "Podaci su uspešno snimljeni")
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			departmentsAPI.post(DepartmentsService.itemToRequest(department)).then(DepartmentsService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: DepartmentsActionTypes.SAVE_COMPLETED, payload: DepartmentsService.fromAPIItem(data)
					})
					actionSetTabStateItem(DepartmentsService.fromAPIItem(data))
					actionSetTabItem(DepartmentsService.fromAPIItem(data))
					actionToastrInfo("Info", "Podaci su uspešno snimljeni")
				}
			).catch(error => ErrorService.handleError(error))
		}
	}

	static delete(department: Department) {

        let departmentsAPI: DepartmentsAPI = new DepartmentsAPI()

		departmentsAPI.delete(DepartmentsService.itemToRequest(department)).then(DepartmentsService.processResponse).then(
			(data) => {
				actionToastrInfo("Info", "Podaci su uspešno obrisani")
				AppStore.dispatch({
					type: DepartmentsActionTypes.DELETE_COMPLETED, payload: department
				})
				actionDeleteTabForItemId(department.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteMultiple(departments: Department[]) {

		let departmentsAPI: DepartmentsAPI = new DepartmentsAPI()
		let count = 0;
		departments.forEach(department => {

			departmentsAPI.delete(DepartmentsService.itemToRequest(department)).then(DepartmentsService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(department.id)
					actionToastrInfo("Info", "Podaci su uspešno obrisani")
					if(count === departments.length)
						AppStore.dispatch({
							type: DepartmentsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: departments
						})
				}
			).catch(error => ErrorService.handleError(error))
		});

	}

    static fromAPIList(apiList: any): Department[] {
        const localList = apiList.map((apiItem: any) => DepartmentsService.fromAPIItem(apiItem));
        //console.info('[fromAPIDepartmentsList] converted departments: ', localList);
        return localList;
    }

    static fromAPIItem(apiItem: any): Department{
        let department = new Department();

        department.id = apiItem.id;
        department.title = apiItem.name;
		department.description = apiItem.description;
		department.parentId = apiItem.parentId;

        return department;
    }

    static itemToRequest (department: Department): any {

		let itemRequest: any = {};

		if(department.id)
        itemRequest.id = department.id;

		itemRequest.name = department.title;
		itemRequest.description = department.description;
		itemRequest.parentId = department.parentId;

		return itemRequest
	}

	static responseToItems (data: any) {
		return data
	}

}
